module.exports = __webpack_public_path__ + "img/com (2).18ce0b65.png";